import React, { useState } from 'react'
import { Button, FormControl, InputGroup } from 'react-bootstrap'

export default function SearchComponent({ disabled, placeholder, children, handleSearch }) {
  const [search, setSearch] = useState('')

  return <>
    <div className="form-group" style={{width: '250px'}}>
      <InputGroup>
        <FormControl
          disabled={disabled}
          placeholder={placeholder}
          onChange={e => setSearch(e.target.value)}
          onKeyPress={e => {
            if(e.key === 'Enter'){
              handleSearch(search)
            }
          }}
          className='border-left-0 search-user-input'
          aria-label="search"
          aria-describedby="search-addon1"
        />
        <Button disabled={disabled} type="button" size="sm" onClick={() => handleSearch(search) }>
          <i className="fas fa-search"></i>
        </Button>
      </InputGroup>
    </div>
    { children }
  </>
}
